import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { map, skipWhile } from 'rxjs/operators';
import { AuthService } from 'addiction-auth';

@Injectable({
    providedIn: 'root',
})
export class LoginGuard {
    constructor(private router: Router, private authService: AuthService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.authService.isDoneLoading$.pipe(
            skipWhile((x) => !x),
            map(() => {
                if (!this.authService.hasValidToken()) {
                    this.router.navigate(['login']);
                    return false;
                } else {
                    return true;
                }
            }),
        );
    }
}
